import { Component, StrictMode, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';
import './guide.css';

/**
 * 描画中の例外でページが真っ白になるのを防ぐ。大きすぎる建築や壊れたデータで
 * 3D側が落ちても、次に何をすればよいかだけは日本語で残す。
 */
class ErrorBoundary extends Component<{ children: ReactNode }, { message: string | null }> {
  state: { message: string | null } = { message: null };

  static getDerivedStateFromError(error: unknown): { message: string } {
    return { message: error instanceof Error ? error.message : String(error) };
  }

  componentDidCatch(error: unknown) {
    // 原因を追えるようにコンソールへは残す。
    console.error(error);
  }

  render() {
    if (this.state.message === null) return this.props.children;
    return (
      <div className="app-crash">
        <h2>ごめんなさい。がめんを ひらけませんでした。</h2>
        <p>
          けんちくが おおきすぎるか、ファイルが こわれているのかもしれません。
          <br />
          ページを もういちど よみこむか、べつの ファイルを ひらいてみてください。
        </p>
        <button type="button" onClick={() => window.location.reload()}>もういちど よみこむ</button>
        <p className="app-crash-detail">{this.state.message}</p>
      </div>
    );
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
